import { MessageService } from 'primeng/api';

import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService: MessageService = inject(MessageService);

  info(message: string) {
    this.messageService.add({
      severity: 'info',
      detail: message,
    });
  }

  success(message: string) {
    this.messageService.add({
      severity: 'success',
      detail: message,
    });
  }

  error(message: string) {
    this.messageService.add({
      severity: 'error',
      detail: message,
    });
  }

  httpError(error: HttpErrorResponse) {
    if (typeof error.error === 'string') {
      this.error(error.error);
      return;
    }

    if (error.error.payload?.content && Object.keys(error.error.payload.content).length > 0) {
      Object.entries(error.error.payload.content).forEach(([_, value]: any) => {
        this.error(value);
      });
    } else {
      this.error(error.error.message || error.message);
    }
  }
}
